import React from "react";
import { Pressable } from "react-native";
import { AHIcon, AHText, Box, ColorType } from "arkh";
import { onPressInHaptic } from "widgets/src/onPressInHaptic";

export function HeaderPickerButton(props: {
  onPress?: () => void;
  value: string;
  tintColor: ColorType;
  icon?: React.ReactElement;
  isCompact: boolean;
}) {
  return (
    <Box
      style={{ flexShrink: 1, height: "100%" }}
      spaceLeft="small"
      spaceRight="xlarge"
    >
      <Pressable
        disabled={!props.onPress}
        onPressIn={onPressInHaptic}
        onPress={props.onPress}
        style={({ pressed }) => ({
          height: "100%",
          alignItems: "center",
          flexDirection: "row",
          cursor: "pointer",
          flexGrow: 0,
          opacity: pressed ? 0.3 : 1,
        })}
      >
        {props.icon ?? null}
        <AHText
          spaceLeft="small"
          spaceRight="xsmall"
          type={props.isCompact ? "subtitle" : "title-small"}
          color={props.tintColor}
          numberOfLines={1}
          selectable={false}
        >
          {props.value}
        </AHText>
        {props.onPress ? (
          <AHIcon type="chevron-down" size="medium" color={props.tintColor} />
        ) : null}
      </Pressable>
    </Box>
  );
}
